import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { tSharedAppDispatch, tSharedAppState } from 'common/modules/ReactShared';

export function useTypedDispatch(): tSharedAppDispatch {
  return useDispatch<tSharedAppDispatch>();
}

export const useTypedSelector: TypedUseSelectorHook<tSharedAppState> = useSelector;
